import { Paper, Tabs, Tab, TextField, LinearProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Edit, SimpleForm, useNotify } from "react-admin";
import { useNavigate, useParams } from "react-router-dom";
import { telemetryService } from "../../../services/TelemetryService";
import JsonEditor from "../../core/JsonEditor";
import BasicEdgeConfigEditor from "../editors/BasicEdgeConfigEditor";

const EditV3EdgeConfig = (props) => {
    const { id } = useParams();
    const notify = useNotify();
    const navigate = useNavigate();

    const [currentTab, setCurrentTab] = useState("basic");
    const [config, setConfig] = useState(null);
    const [serialNo, setSerialNo] = useState(null);
    const [data, setData] = useState(null);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        const fetchConfig = async () => {
            setLoading(true);
            const response = await telemetryService.getEdgeConfig(id);
            const config = response.data.device_config;

            setConfig(config);
            setData(config); // init cached data
            setSerialNo(response.data.serial_no);
            setLoading(false);
        };

        fetchConfig();
    }, [id]);

    const submitHandler = async () => {
        setLoading(true); // TODO let's disable the form and show a circular progress instead of the linear progress

        try {
            await telemetryService.saveEdgeConfig(id, data);

            notify(`Element updated`);

            navigate(`/telemetry/edgeConfig/v3`);
        } catch (e) {
            console.error(e);
            setLoading(false);

            notify(`There was an error saving the device config`, { type: "error" });
        }
    };

    if (isLoading) {
        return (
            <div style={{ paddingBottom: "1rem" }}>
                <LinearProgress />
            </div>
        );
    }

    return (
        <>
            <div style={{ paddingBottom: "1rem" }}>
                <Paper>
                    <Tabs
                        value={currentTab}
                        onChange={(event, value) => setCurrentTab(value)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        centered
                    >
                        <Tab label="Basic" value={"basic"} />
                        <Tab label="Advanced" value={"advanced"} />
                    </Tabs>
                </Paper>
            </div>

            {serialNo && (
                <div
                    style={{
                        marginBottom: ".5em",
                        display: "flex",
                        flexDirection: "column",
                        width: "25%",
                        minWidth: "150px",
                    }}
                >
                    <TextField
                        style={{ margin: ".5em" }}
                        label="Serial Number"
                        value={serialNo}
                        type="search"
                        disabled={true}
                    />
                </div>
            )}

            <div hidden={currentTab != "basic"}>
                {config && (
                    <BasicEdgeConfigEditor
                        config={config}
                        handleData={setData}
                        submitHandler={submitHandler}
                        deviceType={"V3"}
                    />
                )}
            </div>

            <div hidden={currentTab != "advanced"}>
                <Edit {...props}>
                    <SimpleForm>
                        <JsonEditor source="device_config" />
                    </SimpleForm>
                </Edit>
            </div>
        </>
    );
};

export default EditV3EdgeConfig;
